import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { DropzoneAreaBase } from 'material-ui-dropzone';

const MyUploader = ({ defaultValue, rules, name, control,maxFiles ,label }) => {
    const handleAdd = (onChange, files) => newFiles => {
        onChange(files.concat(newFiles));
    };

    const handleDelete = (onChange, files) => deleted => {
        onChange(files.filter(f => f !== deleted));
    };
    return (
        <Controller
            defaultValue={defaultValue || []}
            rules={rules || {}}
            name={name}
            control={control}
            render={({ value,onChange }) => (
                <DropzoneAreaBase
                    dropzoneText="Agregar evidencia(s)"
                    filesLimit={1}
                    inputProps={{ title: 'Solo puede agregar un archivo multimedia' }}
                    maxFileSize={15145728}
                    fileObjects={value}
                    onAdd={handleAdd(onChange, value)}
                    onDelete={handleDelete(onChange, value)}
                    showAlerts={['error']}
                    dropzoneProps={{
                        disabled: maxFiles && value.length === maxFiles
                    }}
                />
            )}
        />
    );
};

export default MyUploader;
